module.exports = __webpack_public_path__ + "media/images/halfday-0f656c92de670e189de7c35099ef0af30474cf103aa62935fa811f59ed2e1657.png";